import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-sky-100 bg-sky-50/30 mt-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <h3 className="font-heading text-xl font-medium text-[#032B44]">EasyIce</h3>
        <p className="text-sm text-slate-600 mt-3 leading-relaxed max-w-xs">
          Ghiaccio alimentare di qualità certificata consegnato in tutta la Calabria dal 2018.
        </p>
      </div>

      <div>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600 mb-4">Contatti</p>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-2.5">
            <Phone className="w-4 h-4 text-sky-700 mt-0.5 shrink-0" />
            <span className="text-slate-700">
              <a href="tel:+393491150597" className="hover:text-[#00A3FF]" data-testid="footer-phone-1">349 1150597</a>
              <span className="mx-1.5 text-slate-300">·</span>
              <a href="tel:+390981239098" className="hover:text-[#00A3FF]" data-testid="footer-phone-2">0981 239098</a>
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <Mail className="w-4 h-4 text-sky-700 mt-0.5 shrink-0" />
            <a href="mailto:easyicecalabria@gmail.com" className="text-slate-700 hover:text-[#00A3FF]" data-testid="footer-email">
              easyicecalabria@gmail.com
            </a>
          </li>
          <li className="flex items-start gap-2.5">
            <MapPin className="w-4 h-4 text-sky-700 mt-0.5 shrink-0" />
            <span className="text-slate-700">Via Ugo D'Atri 5<br />87012 Castrovillari (CS)</span>
          </li>
        </ul>
      </div>

      <div>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600 mb-4">Legale</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/privacy" className="text-slate-700 hover:text-[#00A3FF]" data-testid="footer-privacy">Privacy Policy</Link></li>
          <li><Link to="/termini" className="text-slate-700 hover:text-[#00A3FF]" data-testid="footer-terms">Termini e Condizioni</Link></li>
          <li><Link to="/cookie-policy" className="text-slate-700 hover:text-[#00A3FF]" data-testid="footer-cookies">Cookie Policy</Link></li>
        </ul>
      </div>

      <div>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600 mb-4">Pagamenti</p>
        <p className="text-sm text-slate-600 leading-relaxed">
          Pagamenti sicuri tramite <span className="font-semibold text-[#003087]">Pay</span><span className="font-semibold text-[#009cde]">Pal</span>.
          Conto PayPal, carte (Visa, Mastercard, Amex) o contanti alla consegna.
        </p>
      </div>
    </div>

    <div className="border-t border-sky-100 py-5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between text-xs text-slate-500 flex-wrap gap-2">
        <p>© {new Date().getFullYear()} EasyIce SRLS · P.IVA 03618290781</p>
        <p>Made with ❄ in Calabria</p>
      </div>
    </div>
  </footer>
);

export default Footer;
